module.exports = __webpack_public_path__ + "img/hp9.a8d131b5.png";